/**
 * Who is offered «Multiple days» in New pass. It mirrors the backend rule (businessAccess `_s996_may_give_multi_day`,
 * SAM-996, and `front_desk_pass_type`, SAM-1183) so the option is not shown as a dead end; the backend still decides
 * and answers 400 multi_day_not_allowed / pass_type_one_day.
 *
 * A pass over several days needs a caller of tenant level (admin, xhinola_admin, tenantSettings) or the Front Desk
 * 'all' (business_invitation_all), and a pass type other than Guest and Client Booking, which last one day for
 * everybody. The rule is the one of POST /business_access; a residential invitation has none of it.
 */
export interface MultiDayCaller {
  isAdmin: boolean;
  isTenantSettings: boolean;
  isTenantFrontDesk: boolean;
}

/** Pass types that last one Santo Domingo day whoever gives them (compared by name, as the backend does). */
export const ONE_DAY_PASS_TYPES = ['guest', 'client booking'];

export const callerMayGiveMultiDay = (c: MultiDayCaller): boolean => c.isAdmin || c.isTenantSettings || c.isTenantFrontDesk;

/** A missing type counts as Guest: the backend gives a pass with no type the tenant's Guest type. */
export const isOneDayPassType = (label?: string | null): boolean =>
  ONE_DAY_PASS_TYPES.includes((label ?? 'guest').trim().toLowerCase());

export const offersMultipleDays = (opts: { caller: MultiDayCaller; kind: string; passTypeLabel?: string | null }): boolean => {
  if (opts.kind !== 'business') return true; // residential invitations are not under the business-pass rule
  return callerMayGiveMultiDay(opts.caller) && !isOneDayPassType(opts.passTypeLabel);
};
